import React, { useState, useEffect } from 'react';
import styles from '../../Dor/Home/style.module.css';
import LoadingOverlay from '../../../Components/LoadingOverlay';
import { Button } from '../../../Components';
import HealthHeader from '../../../Components/HealthHeader';
import HealthCards from '../../../Components/HealthCard';
import { searchProducts } from '../../../services/kollectaHealthCore';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [patientCount, setPatientCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await searchProducts({
          customerName: '',
          personalNumber: '',
          studyNumber: '',
          type: 'cirurgias'
        });
        const count = response?.data?.count ?? response?.count ?? 0;
        setPatientCount(count);
      } catch (error) {
        console.error('Erro ao buscar dados de cirurgias:', error);
        setPatientCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleExport = () => {
    navigate('/cirurgias/pesquisa');
  };

  const data = [
    { value: patientCount, label: 'PACIENTES CADASTRADOS' },
    { value: '-', label: 'ÍNDICE DE ADESÃO AO ESTUDO' }
  ];

  return (
    <div className={styles.container}>
      <LoadingOverlay isLoading={loading} />
      <HealthHeader title="Dashboard de Pacientes - Cirurgias" />
      <div className={styles.content}>
        <div className={styles.buttonContainer}>
          <Button onClick={handleExport}>Ver Pacientes</Button>
        </div>
        <HealthCards items={data} />
      </div>
    </div>
  );
};

export default Home;
